import type { Variant } from '../../lib/flotiq-client/types/api-response';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { patchMedia } from '../../lib/flotiq-client/api-helpers';

import useSelectedSpace from '../useSelectedSpace';
import useToken from '../useToken';

type UpdateVariantsFn = (
  mediaId: string,
  variants: Variant[],
  isDeleting?: boolean,
) => undefined | Promise<any>;

const useMediaUpdateVariants = () => {
  const jwt = useToken();
  const { space } = useSelectedSpace();
  const { t } = useTranslation();

  const updateVariants = useCallback<UpdateVariantsFn>(
    (mediaId, variants, isDeleting = false) => {
      if (!jwt || !mediaId) return;

      return patchMedia(
        jwt,
        space,
        mediaId,
        {
          variants,
        },
        t,
        isDeleting
          ? t('MediaEdit.Variant.Deleted')
          : t('MediaEdit.Variant.Updated'),
        isDeleting
          ? t('MediaEdit.Variant.DeleteError')
          : t('MediaEdit.Variant.UpdateError'),
      );
    },
    [jwt, t, space],
  );

  return { updateVariants };
};

export default useMediaUpdateVariants;
